import React, { useState } from "react";
/// React router dom
import { Switch, Route } from "react-router-dom";
/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";

/// Pages
import Login from "./pages/Login";
import AppVersionManagement from "./pages/AppVersionManagement";

//Scroll To Top
import ScrollToTop from "./layouts/ScrollToTop";
import UserManagement from "./pages/UserManagement";
import VipUsersManagement from "./pages/VipUsersManagement";
import ConfigTable from "./pages/ConfigTable";
import ClassifierSettings from "./pages/ClassifierSettings";
import ErrorTelemetry from "./pages/ErrorTelemetry";
import OcrTestSuite from "./pages/OcrTestSuite";
import OcrTestCompanies from "./pages/OcrTestCompanies";
import AiJobCreation from "./pages/AiJobCreation";

const Markup = () => {
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];
  let pagePath = path.split("-").includes("page");
  const [activeEvent, setActiveEvent] = useState(!path);

  const routes = [
    { url: "", component: UserManagement },
    { url: "dashboard", component: UserManagement },
    { url: "user-management", component: UserManagement },
    { url: "vip-users-management", component: VipUsersManagement },
    { url: "tax-management", component: ConfigTable },
    { url: "app-version-management", component: AppVersionManagement },
    { url: "classifier-settings", component: ClassifierSettings },
    { url: "ai-job-creation", component: AiJobCreation },
    { url: "error-telemetry", component: ErrorTelemetry },
    { url: "ocr-test-suite", component: OcrTestSuite },
    { url: "test-companies", component: OcrTestCompanies },
    { url: "page-login", component: Login },
  ];

  return (
    <>
      <div
        id={`${!pagePath ? "main-wrapper" : ""}`}
        className={`${!pagePath ? "show" : "mh100vh"}`}
      >
        {!pagePath && (
          <Nav
            onClick={() => setActiveEvent(!activeEvent)}
            activeEvent={activeEvent}
            onClick2={() => setActiveEvent(false)}
            onClick3={() => setActiveEvent(true)}
          />
        )}
        <div
          className={` ${!path && activeEvent ? "rightside-event" : ""} ${
            !pagePath ? "content-body" : ""
          }`}
        >
          <div
            className={`${!pagePath ? "container-fluid" : ""}`}
            style={{ minHeight: window.screen.height - 60 }}
          >
            <Switch>
              {routes.map((data, i) => (
                <Route
                  key={i}
                  exact
                  path={`/${data.url}`}
                  component={data.component}
                />
              ))}
            </Switch>
          </div>
        </div>
        {!pagePath && <Footer />}
      </div>
      <ScrollToTop />
    </>
  );
};

export default Markup;
